import React, { Component } from 'react';
import { connect } from 'react-redux';

import ChangeGrid from "./ChangeGrid";
import Grid from "./Grid";
import AddGrid from "./AddGrid";
import DeleteGrid from "./DeleteGrid";
import moment from 'moment'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Search from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as DirectDebitCheck from './Saga/DirectDebitCheck';
import { makeStyles, withStyles } from '@material-ui/core/styles';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    // direct_debit_types: any,
    get_direct_debit_types: any,
    get_kozalist: any,
    addlist: any,
    deletelist: any,
    changelist: any,
    // get_so_ymd_list: any,
    // search_detail: any,
    // classes: any,
    // search_loading: boolean,
}



interface State {

    // state types
}


const styles = ((theme: any) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))



class CustomerList extends Component<Props, State> {
    componentWillMount() {
        this.props.get_direct_debit_types()
        this.props.get_kozalist()
        // this.props.get_so_ymd_list()

        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        // this.props.get_owner_remittance_check_logs(state)
    }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {/* {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse} */}
                    <div className="item">
                        <Search />

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-6"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <span style={{ float: "left" }}>金額相違</span> <span style={{ float: "right" }}>{this.props.changelist.length}件</span>
                        <ChangeGrid />

                    </div>
                </div>

                <div className="item-outer col-lg-6"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <span style={{ float: "left" }}>詳細</span>
                        <Grid />

                    </div>
                </div>

                <div className="item-outer col-lg-6"
                // style={{ height: 200 }}
                >
                    <div className="item">
                        <span style={{ float: "left" }}>引落開始月で未請求</span> <span style={{ float: "right" }}>{this.props.addlist.length}件</span>
                        <AddGrid />

                    </div>
                </div>
                <div className="item-outer col-lg-6"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <span style={{ float: "left" }}>解約月以降で請求</span> <span style={{ float: "right" }}>{this.props.deletelist.length}件</span>
                        <DeleteGrid />

                    </div>
                </div>


                {/* <Backdrop className={this.props.classes.backdrop} open={this.props.search_loading} > */}
                {/* <CircularProgress color="inherit" /> */}
                {/* </Backdrop> */}
            </div >
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        search_loading: state.ContractCheck.search_loading,
        owner_remittance_check_logs: state.RemittanceLogCheck.owner_remittance_check_logs,
        deletelist: state.DirectDebitCheck.deletelist,
        changelist: state.DirectDebitCheck.changelist,
        addlist: state.DirectDebitCheck.addlist,
        direct_debit_details: state.DirectDebitCheck.direct_debit_details,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        get_direct_debit_types(state: any) {
            dispatch(DirectDebitCheck.get_direct_debit_types(state))
        },
        get_kozalist(state: any) {
            dispatch(DirectDebitCheck.get_kozalist(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomerList));




